import React from 'react';
import Spinner from './spinner';
import styled from 'styled-components';
import './spinnerstyle.css';

const ContentSpinner = styled.div`
    width: 100%;
    height: 100%;
    background-color: black;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2000;
    opacity: 0.6;
    display: block;
`; 
export default class Loading extends React.Component{
	render(){
		 if (!this.props.isLoading)
			return null 

		return(
			<ContentSpinner>
				<Spinner/>
			</ContentSpinner>
		)
	}
} 